/**
 * @(#)2020/02/27.
 * 状态组件
 * @author 足道
 * Copyright (c) 2019, YUNXI. All rights reserved.
 * YUNXI PROPRIETARY/CONFIDENTIAL. Use is subject to license terms.
 */
import "./index.less";
import Icon from "../Icon";
import { Tooltip } from "antd";
import React, { Component } from "react";
import { l } from "../../../config/language";
import { get, nodeFactory, merge } from "../../../utils";
import { YxComponent, Connection } from "../../YxComponent";

/*
 * YxStatus
 * @param children {reactNode} 子节点
 * @return {ReactNode}
 * */
const defulatProps = function () {
  return {
    children: "",
    styleType: "tag", // tag icon  circle
    styleParam: {
      type: "tag", // 类型 tag icon  circle
      size: "default", // 尺寸
    },
    type: null, // 常规提示info 警告提示warning 成功提示success 错误提示error
    text: null, // 展示文本，可空
    solid: true, // 是否实心 当styleType为icon时生效
    iconParam: {}, // 额外的参数 当icon时生效
  };
};

/**
 * @param {string} styleType 样式类型 tag icon  circle
 * @param {object} textDict 文字字典 不同状态对应的文案
 * @param {string} styleParam.type 样式类型 tag icon  circle
 * @param {string} styleParam.size 样式尺寸 暂时只支持默认
 * @param {string} type 状态类型 常规提示info 警告提示warning 成功提示success 错误提示error
 * @param {string} text 展示文本，可空
 * @param {boolean} solid 是否实心 当styleType为icon时生效
 * @param {object} iconParam 额外的参数 当icon时生效
 *
 * @class Status
 * @extends {YxComponent}
 */
@Connection(defulatProps)
class Status extends YxComponent {
  constructor(props, context) {
    super(props, context);
    this.state = {
      extraClass: "",
    };
    this.baseClassName = "yx_yxText_status";
  }

  get type() {
    const result = get(this.props, ["type", "children"], "info");
    return nodeFactory(result, this.props);
  }

  get baseTextFromDict() {
    const dict = {
      info: l("YxStatus.it", this),
      warning: l("YxStatus.wt", this),
      success: l("YxStatus.st", this),
      error: l("YxStatus.et", this),
    };
    const textDict = get(this.props, "textDict", {});
    return merge(dict, textDict)[this.type];
  }

  get text() {
    const text = get(this.props, "text", null);
    if (text == null) {
      return this.baseTextFromDict;
    }
    return nodeFactory(text, this.props.data);
  }

  get currentClass() {
    const newProps = {
      ...this.props,
      styleParam: { ...this.props.styleParam },
    };
    newProps.styleParam.type = get(this.props, "styleType", "tag");
    let classParam = {
      yx_yxText_status_: "styleParam.type",
      yx_yxText_status_size_: "styleParam.size",
    };
    const result = this.styleParamClassName(newProps, classParam);
    return result;
  }

  renderTag = () => {
    return this.text;
  };

  renderCircle = () => {
    const DOM = (
      <div className="circle_box">
        <span className="circle"></span>
        <div className="describe">{this.text}</div>
      </div>
    );
    return DOM;
  };

  renderIcon = () => {
    const dict = {
      info: ["iconzhuangtai_Style3", "iconzhuangtai_Style5"],
      warning: ["iconzhuangtai_Style6", "iconzhuangtai_Style4"],
      success: ["iconzhuangtai_Style", "iconzhuangtai_Style"],
      error: ["iconzhuangtai_Style1", "iconzhuangtai_Style7"],
    };
    const baseIconType = dict[this.type];
    const solid = get(this.props, "solid", true);
    const iconParam = get(this.props, "iconParam", {});
    return (
      <Icon
        iconfont
        type={solid === true ? baseIconType[0] : baseIconType[1]}
        {...iconParam}
      />
    );
  };

  productionHtml = () => {
    const styleType = get(this.props, "styleType", "tag");
    const dict = {
      tag: this.renderTag,
      icon: this.renderIcon,
      circle: this.renderCircle,
    };
    const DOM = get(dict, styleType, () => <div></div>)();
    return DOM;
  };

  render() {
    const titps = get(this.props, "titps", null);
    const param = {
      showtype: this.type,
      className: this.currentClass,
    };
    return (
      <div {...param}>
        <Tooltip title={titps || this.baseTextFromDict}>
          {this.productionHtml()}
        </Tooltip>
      </div>
    );
  }
}

export default Status;



// WEBPACK FOOTER //
// ./src/yx-widget/component/YxText/Status/status.js